import { Component, OnInit, ViewChild } from '@angular/core';
import { InternalHomeService } from '../../internal-home.service';
import { Wsdefs } from '../../../../../core/entities/wsdefs.model';
import { MatDialog } from '@angular/material/dialog';
import { EditDialogsWsdefsComponent } from './dialogs-wsdefs/edit-dialogs-wsdefs/edit-dialogs-wsdefs.component';
import { DialogsConfirmComponent } from '../../../../../shared/components/dialogs/dialogs-confirm/dialogs-confirm.component';
import { DialogsPermissionsComponent } from '../../../../../shared/components/dialogs/dialogs-permissions/dialogs-permissions.component';
import { TranslateService } from '@ngx-translate/core';
import { FormCanDeactivate } from '../../../../../core/guards/deactivate/form-can-deactivate';
import { NgForm } from '@angular/forms';
import { Utils } from 'src/app/core/utils/utils';
import { DialogsAlertComponent } from 'src/app/shared/components/dialogs/dialogs-alert/dialogs-alert.component';
import { UNAUTHORIZED, FORBIDDEN } from '../../../../../core/utils/constants';

@Component({
  selector: 'app-wsdefs',
  templateUrl: './wsdefs.component.html',
  styleUrls: ['./wsdefs.component.scss']
})
export class WsdefsComponent extends FormCanDeactivate implements OnInit {

  @ViewChild('f', {static: true})
  form!: NgForm;
  loading: boolean = true;
  wsdefs: Wsdefs = new Wsdefs();

  mensajeError: boolean = false;

  constructor(
    public internalHomeService: InternalHomeService,
    private dialog: MatDialog,
    private translateService: TranslateService) {
    super();
  }

  ngOnInit() {
    this.mensajeError = false;
    this.getAllWsdefs();
    this.internalHomeService.mostrarMenu();
  }

  /**
  * @description
  * Se llama al servicio para traernos todos los datos de la tabla wsdefs
  */
  private getAllWsdefs(): void {
    this.loading = true;
    this.internalHomeService.allWsdefs().subscribe(res => {
        console.log(res);
        this.loading = false;
    }, error => {
        this.mensajeError = true;
        this.loading = false;
        this.showMsg(error);
        console.log("Error: " + error);
    });
  }

  /**
  * @description
  * Abre el dialog para crear un wsdefs
  * @param parametro Opcional. Wsdefs vacio.
  */
  public createWsdef(wsdefs?: Wsdefs) {
    Utils.toggleAllButtonsAndHref(true);
    let titulochange = false;
    wsdefs = this.wsdefs;
    let anchodisp: string = "";
    window.screen.width < 500 ? anchodisp = '85%' : anchodisp = "70%";
    const dialogRef = this.dialog.open(EditDialogsWsdefsComponent, {
      width: anchodisp,
      disableClose: true,
      hasBackdrop: true,
      data: { wsdefs, titulochange }
    });
    Utils.accessibilityDialogCdk();
    dialogRef.afterClosed().subscribe((result: boolean) => {
      Utils.toggleAllButtonsAndHref(false);
      if(result)
      setTimeout(() => {
        this.getAllWsdefs();
      }, 1000);
    });
  }

  /**
  * @description
  * Abre el dialog para crear o modificar un wsdefs
  * @param parametro Opcional. Wsdefs a editar. Si vamos a crear será undefined
  */
  public editWsdef(wsdefs?: Wsdefs) {
    Utils.toggleAllButtonsAndHref(true);
    let titulochange = true;
    let anchodisp: string = "";
    window.screen.width < 500 ? anchodisp = '85%' : anchodisp = "70%";
    const dialogRef = this.dialog.open(EditDialogsWsdefsComponent, {
      width: anchodisp,
      disableClose: true,
      hasBackdrop: true,
      data: { wsdefs, titulochange}
    });
    Utils.accessibilityDialogCdk();
    dialogRef.afterClosed().subscribe((result: boolean) => {
      Utils.toggleAllButtonsAndHref(false);
      if(result){
        setTimeout(() => {
          this.getAllWsdefs();
        }, 1000);
      }
    });
  }


  /**
  * @description
  * Elimina un wsdefs
  * @param dato Wsdefs a eliminar
  */
  public removeWsdef(wsdefs?: Wsdefs) {
    Utils.toggleAllButtonsAndHref(true);
    const dialogRef = this.dialog.open(DialogsConfirmComponent, {
      disableClose: true,
      hasBackdrop: true,
      data: { texto: this.translateService.instant('WARNINGS.dato_wsdef') }
    });
    Utils.accessibilityDialogCdk();
    dialogRef.afterClosed().subscribe(result => {
      Utils.toggleAllButtonsAndHref(false);
      if (result) {
        this.loading = true;
        this.internalHomeService.removeWsdefs(wsdefs).subscribe(res => {
            console.log(res);
            this.getAllWsdefs();
            this.loading = true;
        }, error => {
          this.loading = false;
          console.log("Error: " + error);
        });
      }
    });
  }

  /**
  * @description
  * Abre el dialog para modificar un permiso de wsdefs
  * @param parametro Permiso de Wsdefs a editar
  */
  public permissionWsdef(wsdefs?: Wsdefs){
    if (!wsdefs) return;
    Utils.toggleAllButtonsAndHref(true);
    let titulochange = true;
    let clasepermisos = this.translateService.instant('TABLAS.wsdef');
    let objectpermisos = wsdefs.code;
    let idpermisos = wsdefs.id;
    console.log(wsdefs);
    const dialogRef = this.dialog.open(DialogsPermissionsComponent, {
      width: '85%',
      disableClose: true,
      hasBackdrop: true,
      data: { wsdefs, titulochange, clasepermisos, objectpermisos, idpermisos }
    });
    Utils.accessibilityDialogCdk();
    dialogRef.afterClosed().subscribe((result: Wsdefs) => {
      Utils.toggleAllButtonsAndHref(false);
      console.log(result);
    });
  }

  /**
  * Muestra el mensaje de error correspondiente en caso de error
  * @param error Objeto de error.
  */
  private showMsg(error: any) {
    const msg: string = error == null || (error != null && (error.status !== UNAUTHORIZED && error.status !== FORBIDDEN)) ? this.translateService.instant('ACCESO.loginError') : this.translateService.instant('ACCESO.loginError' + error.status);
    this.dialog.open(DialogsAlertComponent, {
      data: { texto: msg }
    });
  }

}
